/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualTaxDto } from '../../models/backend-actual-tax-dto';
import { BackendActualTaxRequestDto } from '../../models/backend-actual-tax-request-dto';

export interface MonitoringActualsTaxesCreate$FormData$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
  body: BackendActualTaxRequestDto;
}

export function monitoringActualsTaxesCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsTaxesCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualTaxDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsTaxesCreate$FormData.PATH, 'post');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualTaxDto>;
    }),
  );
}

monitoringActualsTaxesCreate$FormData.PATH = '/api/monitoring/actuals/taxes/';
